// D-1085 案 1: どの画面からでも開ける「不具合・要望」のシート。App に 1 つだけ置く(ログイン中だけ)。
//   開く合図は shared/ui/feedbackBus(各画面の「?」の一番下の 1 行・ほかの画面の openFeedback)。
//   ★route は FeedbackSheet が送るときの useLocation().pathname(= 開いていた画面の実際のパス)。
//   ★店は openFeedback({ storeCode }) で渡されたらそれ、無ければ今のパスから決める(storeCodeFromPath)。
//     fn_feedback_submit は stores に無いコードを NULL にするので、取り違えても送信は落ちない。
//   ★ページの中ではなく App の直下に置く(祖先の transform で fixed がずれる D-937 を避ける)。
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import FeedbackSheet from './FeedbackSheet'
import { subscribeFeedback } from '../shared/ui/feedbackBus'
import { useAuth } from '../hooks/useAuth'

/** パスから店のコードを決める。`/store/:s`(後ろに続いても可)→ s、`/clawsupport/booth/:b` → b の最初の「-」の前。 */
export function storeCodeFromPath(pathname) {
  if (typeof pathname !== 'string' || pathname === '') return null
  const seg = pathname.split('?')[0].split('#')[0].split('/').filter(Boolean).map(s => {
    try { return decodeURIComponent(s) } catch { return s }
  })
  const si = seg.indexOf('store')
  if (si >= 0 && seg[si + 1]) return seg[si + 1]
  const bi = seg.indexOf('booth')
  if (seg[0] === 'clawsupport' && bi === 1 && seg[2]) return seg[2].split('-')[0] || null
  return null
}

export default function FeedbackHost() {
  const { staffId } = useAuth()
  const location = useLocation()
  const [req, setReq] = useState(null) // null = 閉じている / { storeCode }

  useEffect(() => subscribeFeedback(r => setReq({ storeCode: r?.storeCode ?? null })), [])

  const storeCode = req ? (req.storeCode || storeCodeFromPath(location.pathname)) : null
  return (
    <FeedbackSheet open={!!req} onClose={() => setReq(null)} staffId={staffId} storeCode={storeCode} />
  )
}
